import useGetTreatment from 'hooks/treatments/useGetTreatment'
import { TreatmentFlags, treatmentFlagValues } from 'constants/treatments'
import { isPatientUser } from 'utils/common'

/**
 * Waterfall simplification A/B test (THRIV-13273).
 *
 * `isPatientUser()` keeps the test DTC-only — COE, support and third-party users
 * always get control, which also excludes ThriveWeb / B2B V1.
 */
export function useWaterfallSimplification(): { isEnabled: boolean } {
  const treatment = useGetTreatment(
    TreatmentFlags.WATERFALL_SIMPLIFICATION,
    isPatientUser()
  )

  return { isEnabled: treatment === treatmentFlagValues.ON }
}

export default useWaterfallSimplification
